import type { AgentOutputProps } from '../types'

/**
 * Renders video_gen output.
 *
 * Looks for a video URL in (priority order):
 *   1. result.video_url
 *   2. result.agent_data.video_url
 *   3. /app/video_output/<file>.mp4 pattern inside a string output → served via
 *      /api/v1/video-gen/output/<file>
 */
function extractVideoUrl(result: any): string | null {
  if (!result) return null
  if (typeof result === 'string') {
    const m = result.match(/\/app\/video_output\/([^\s"']+\.mp4)/)
    if (m) return `/api/v1/video-gen/output/${m[1]}`
    return null
  }
  if (typeof result.video_url === 'string') return result.video_url
  const ad = result.agent_data || {}
  if (typeof ad.video_url === 'string') return ad.video_url
  const content = ad.content || result.content || ''
  if (typeof content === 'string') {
    const m = content.match(/\/app\/video_output\/([^\s"']+\.mp4)/)
    if (m) return `/api/v1/video-gen/output/${m[1]}`
  }
  return null
}

export default function VideoRenderer({ result }: AgentOutputProps) {
  const url = extractVideoUrl(result)
  if (!url) {
    return (
      <div className="text-sm text-muted-foreground italic">
        No video URL found in the agent result.
      </div>
    )
  }
  return (
    <div className="space-y-2">
      <video
        src={url}
        controls
        className="w-full max-w-3xl rounded-lg border border-border bg-black"
      />
      <div className="text-xs text-muted-foreground">
        <a href={url} className="underline" target="_blank" rel="noreferrer">
          Open MP4 in new tab
        </a>
      </div>
    </div>
  )
}
